import React, { useEffect, useState } from "react";
import "./create-invoice-client.scss";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from "@material-ui/core/Checkbox"
import Button from "@material-ui/core/Button";
import DialogTitle from "../../../../../../../.TrainerOffice/components/hoc/dialog-title";
import SelectReact from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  CircularIndeterminate,
  customStylesClient,
} from "../../../../training-client/training-client";
import { getCreateInvoiceClientSelector } from "../../../../../../../selectors/invoice-selectors";
import { requestGroupScheduleForClient } from "../../../../../../../store/actions/selects";
import {
  createInvoiceForClient,
  invoiceLoaded,
} from "../../../../../../../store/actions/invoice";
import { Redirect } from "react-router";

const CreateInvoiceClient = (props) => {
  const { open, close, child } = props;
  const dispatch = useDispatch();
  const groupId = child.groups[0]?.id;
  useEffect(() => {
    dispatch(requestGroupScheduleForClient(groupId));
  }, [dispatch, groupId]);
  const data = useSelector((state) =>
    getCreateInvoiceClientSelector(state, child.invoices)
  );
  const loading = useSelector((state) => state.selects.scheduleGroupLoading);
  const discount = useSelector((state) => state.discount.invoiceDiscount);
  const [invoice, setInvoice] = useState({
    valid: [],
    children_id: "",
    group_id: groupId,
    count: 0,
  });
  const [refund_flag, setRefundFlag] = useState(false)
  const [checkAllFlag, setCheckAllFlag] = useState(false)

  const onCheckInvoiceUpdate = () => {
      const {children_id, count, group_id, valid} = invoice
      const ajaxObject = {
          children_id,
          count,
          group_id,
          estimation: true,
          schedule_ids: valid.map(v => v.id),
          is_refundable: refund_flag
      }
      if (!valid.length) {
          dispatch(invoiceLoaded([]))
      } else {
          dispatch(
              createInvoiceForClient(ajaxObject)
          );
      }
  }
  const handleDivClicked = (event) => {
    const { valid, group_id } = invoice;
    const validNew = valid.find((item) => item.date === event.date)
      ? valid.filter((item) => item.date !== event.date)
      : [...valid, event];
    setInvoice((prevState) => ({
      ...prevState,
      valid: validNew,
      children_id: child.id,
      count: validNew.length,
    }))
    const schedule_ids = validNew.map((el) => el.id);
    if (schedule_ids.length === 0) {
      dispatch(invoiceLoaded([]));
    } else
      dispatch(
        createInvoiceForClient({
          children_id: child.id,
          group_id,
          count: validNew.length,
          schedule_ids: schedule_ids,
          estimation: true,
          is_refundable: refund_flag
        })
      );
  };

  const createInvoiceClient = () => {
    dispatch(
      createInvoiceForClient({
        children_id: invoice.children_id,
        group_id: invoice.group_id,
        count: invoice.count,
        schedule_ids: invoice.valid.map((el) => el.id),
        estimation: false,
        is_refundable: refund_flag
      })
    );
  };
  useEffect(() => {
      onCheckInvoiceUpdate();
   }, [refund_flag])

  useEffect(() => {
      onCheckAllInvoiceUpdate()
  }, [checkAllFlag]);

  const onCheckAllInvoiceUpdate = () => {
    if (filterSchedule.length) {
        const { group_id } = invoice
        const mapIds = filterSchedule.map(fs => fs.id)
        console.log(mapIds, 'mapIds')
        setInvoice((prevState) => ({
            ...prevState,
            valid: filterSchedule,
            children_id: child.id,
            count: filterSchedule.length,
            group_id: group_id
        }))
        const ajaxObject = {
            children_id: child.id,
            count: filterSchedule.length,
            group_id,
            estimation: true,
            schedule_ids: mapIds,
            is_refundable: refund_flag
        }
        console.log(checkAllFlag, 'is here')
        if (!checkAllFlag) {
            setInvoice((prevState) => ({
                ...prevState,
                valid: [],
                children_id: child.id,
                count: 0,
                group_id: group_id
            }))
            dispatch(invoiceLoaded([]))
        } else {
            dispatch(
                createInvoiceForClient(ajaxObject)
            )
        }
    }
  }
  const onRefundHandler = (e) => {
      setRefundFlag(e.target.checked)
  }
  const onCheckAllHandler = (e) => {
      setCheckAllFlag(e.target.checked)
  }
  const byInvoice = () => {
    createInvoiceClient();
  };
  const setGroup = (group) => {
    dispatch(requestGroupScheduleForClient(group.id));
    setInvoice({
      valid: [],
      children_id: "",
      group_id: group.id,
      count: 0,
    });
    dispatch(invoiceLoaded({}));
  };

  const filterSchedule = data.sortScheduleMonth

  const closeCreateInvoice = () => {
    close(!open);
    dispatch(invoiceLoaded([]));
  };

  if (discount.id) {
    return <Redirect to={`/client/invoice/${discount.id}`} />;
  }

  return (
    <Dialog
      open={open}
      aria-labelledby="form-dialog"
      fullWidth
      PaperProps={{
        style: {
          backgroundImage: "linear-gradient(180deg, #FAFAFC 0%, #ECECEC 100%)",
          boxShadow: "none",
          width: "100%",
          margin: 0,
        },
      }}
      maxWidth={"lg"}
      id="dialog-create-invoice-client-container"
    >
      <DialogTitle
        id="dialog-create-invoice-client-title"
        onClose={closeCreateInvoice}
      >
        <div className="createInvoiceClientTitle">
          <h2>Приобретение занятий</h2>
          <span>
            Выберите месяц, год и дни, в которые вы собираетесь посещать занятия
          </span>
        </div>
      </DialogTitle>
      <DialogContent id="dialog-create-invoice-client-content">
        <div className="createInvoiceClientDateContainer">
          {child.groups.length > 1 && (
            <div className="createInvoiceClientDateGroup">
              <span className="createInvoiceClientYear">Группа</span>
              <SelectReact
                className="selectCreateInvoiceClientGroup"
                name="group"
                inputProps={{ readOnly: true }}
                isSearchable={false}
                defaultValue={child.groups[0]}
                getOptionLabel={(x) => x.name}
                getOptionValue={(x) => x.name}
                options={child.groups}
                styles={customStylesClient}
                onChange={setGroup}
              />
            </div>
          )}
        </div>
        {!loading ? (
          <>
              <div className="check-all-element">
                  <FormControlLabel control={<Checkbox color="primary"
                                                       checked={checkAllFlag}
                                                       onChange={onCheckAllHandler}
                  />} label={"Выбрать всё"} />
              </div>
            <div className="createInvoiceClientBalance">
              <span>Занятия на балансе</span>
              <span id="balanceCount">0</span>
            </div>
            <div className="createInvoiceClientItem">
              {filterSchedule.length > 0 ? (
                filterSchedule.map((item) => (
                  <div
                    className={
                      invoice.valid.findIndex((el) => el.date === item.date) >
                      -1
                        ? "createInvoiceItemSelect item--xs"
                        : "createInvoiceItem item--xs"
                    }
                    onClick={() => handleDivClicked(item)}
                    key={item.id}
                  >
                    <span id="invoiceItemDate">{item.day}</span>
                    <span id="invoiceItemTime">{`${item.start}-${item.end}`}</span>
                    <span id="invoiceItemDay">{item.dayName}</span>
                  </div>
                ))
              ) : (
                <h3>Занятия на выбранный месяц отсутствуют</h3>
              )}
            </div>
            <div className="check-all-element">
                <FormControlLabel control={<Checkbox color="primary" checked={refund_flag}
                                                     disabled={!invoice.valid.length}
                onChange={onRefundHandler}
                />} label={"Возвратный абонемент"} />
            </div>
            <div className="invoiceDiscountClientContainer">
              <h2>Ваш выбор:</h2>
              <div className="discountClientLessons">
                <span id="lesson">Занятия</span>{" "}
                <label>
                  {discount.count || 0}
                  <span id="price"> = {discount.start_price || 0} р</span>
                </label>
              </div>
              <div className="discountClientValue">
                <span id="labelValue">Занятий на балансе</span> <label>0</label>
              </div>
              {discount.discounts?.map((item) => (
                <div className="discountClientValue" key={item.name}>
                  <span id="labelValue">{item.name}</span>{" "}
                  <label>{item.value}р</label>
                </div>
              ))}
              {discount.refundable_part ? <div className="discountClientValue">
                  <span className="span-label">Возвратный абонемент (+10%)</span>{" "}
                  <label>+{discount.refundable_part}р</label>
              </div> : ''}
              <div className="invoiceClientFinishPrice">
                <span id="labelPrice">Итоговая стоимость</span>
                <label>{discount.price || 0} р</label>
              </div>
            </div>
          </>
        ) : (
          <CircularIndeterminate />
        )}
        <div id="dialog-create-invoice-client-actions">
          <Button id="btnCancel" onClick={closeCreateInvoice}>
            Отмена
          </Button>
          <Button disabled={invoice.count === 0} onClick={byInvoice}>
            Приобрести занятия
          </Button>
        </div>
        <div className="createInvoiceClientFooter">
          <p id="footerInvoiceInfo">
            После создания абонемента, вас перенаправит в карточку абонемента,
            где вы сможете его оплатить.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CreateInvoiceClient;
